import React from 'react';
import './StatsRow.css';

const fmt = (n) => {
  if (n >= 1000) return (n / 1000).toFixed(1) + 'k';
  return n;
};

const stats = (followers, repos, activeDays, commitCount) => [
  { label: 'Followers', value: fmt(followers), sub: 'people' },
  { label: 'Public repos', value: fmt(repos), sub: 'projects' },
  { label: 'Active days', value: activeDays, sub: 'last 90 events' },
  { label: 'Recent commits', value: commitCount, sub: 'last 90 events' },
];

export default function StatsRow({ followers, repos, activeDays, commitCount }) {
  const items = stats(followers, repos, activeDays, commitCount);
  return (
    <div className="stats card card--mb">
      {items.map((s, i) => (
        <div className="stats__item" key={i}>
          <span className="stats__value">{s.value}</span>
          <span className="stats__label">{s.label}</span>
          <span className="stats__sub">{s.sub}</span>
        </div>
      ))}
    </div>
  );
}
